/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import routerLoader from '../../../i18n/router';
// eslint-disable-next-line import/named
import FacturacionOroForm from './FacturacionOroForm';
import { PaisesOro, TiposVia } from '../../../types/PersonalData';
import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
import { TarjetaService } from '../../../services';
import { TarjetaOroHelper } from '../TarjetaOroHelper';
import { PriceFormatter } from '../../../utils/PriceFormatter';
import { TarjetasOroConstants } from '../TarjetasOroConstants';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { StorageHelper } from '../../../utils/StorageHelper';
import { useAppStore } from '../../../store/AppContext';
import { GtmManager } from '../../../utils/GtmManager';
import { IPManager } from '../../../utils/IPManager';
import DataService from '../../../services/MisDatosService';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import IconBack from '../../../Icons/IconBack';
import { CryptoUtil } from '../../../utils/CryptoUtil';
import { GtmConstants } from '../../../utils/GtmConstants';
import { BackMappings } from '../../../utils/BackMappings';
import { HostProvider } from '../../../utils/HostProvider';
import { useMisDatosStore } from '../../MisDatos/context/MisDatos.context';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  isDatosIncompletos: boolean;
  setReload?: (visible: boolean) => void;
  setErrorMDM: (error: boolean) => void;
}
const SolictarTarjetaOroForm: FC<Props> = (props) => {
  const {
    visible,
    setVisible,
    isDatosIncompletos,
    setReload,
    setErrorMDM,
  } = props;
  const { t } = useTranslation();
  const [postalCode, setPostalCode] = useState<string>();
  const [roadName, setRoadName] = useState<string>();
  const [door, setDoor] = useState<string>();
  const [floor, setFloor] = useState<string>();
  const [stairs, setStairs] = useState<string>();
  const [number, setNumber] = useState<string>();
  const [localidad, setLocalidad] = useState<string>();
  const [portal, setPortal] = useState<string>();
  const [roadType, setRoadType] = useState<string>();
  const [cuenta, setCuenta] = useState<string>();
  const [pais, setPais] = useState<string>('AF');
  const [cuota, setCuota] = useState<number>(4);
  const [roadTypeDesc, setRoadTypeDesc] = useState<string>();
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const {
    showModalContactEmail,
    hideModalV2P,
    showModalV2P,
    showModalV2PPopupSamePage,
  } = useMisDatosStore();
  const [ipValue, setIpValue] = useState('' as string);
  const [load, setLoad] = useState<boolean>(false);
  const { moneda } = dataUser.user;
  const [showModal, setShowModal] = useState(false as boolean);
  const [showModalDatos, setShowModalDatos] = useState(false as boolean);
  const [showModalConfirmacion, setShowModalConfirmacion] = useState(
    false as boolean,
  );
  const [modalText, setModalText] = useState('' as string);
  const [modalTitle, setModalTitle] = useState('' as string);
  const { addError, addOro, addWarning, addErrorBack } = useAPIError();
  const [tiposVia, setTiposVia] = useState<TiposVia[]>([]);
  const [paises, setPaises] = useState<PaisesOro[]>([]);
  const [showError, setShowError] = useState(false);
  const [showErrorOro, setShowErrorOro] = useState(false);
  const [titleError, setTitleError] = useState('' as string);
  const [messageError, setMessageError] = useState('' as string);
  const TIPOTARJETA_TITULAR_Y_ORO = 4;
  const TIPOTARJETA_NO_ORO = 0;

  const priceFormatter = (value: any) => {
    const monedaText = moneda === 'euro' ? t('euro') : t('cc');
    return PriceFormatter.formatStringAsPrice(value as string, monedaText);
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {
    StorageHelper.removeOpenPersonalData();
  };

  const getTipoUsuarioTarjeta = () => {
    return Number(
      CryptoUtil.decrypt(
        sessionStorage.getItem('tipoUsuarioTarjetaOro') as string,
      ),
    );
  };

  const getPaises = () => {
    TarjetaService.getPaisesOro()
      .then((response) => {
        if (response.data.error) {
          const tipoUsuario = getTipoUsuarioTarjeta();

          if (tipoUsuario === TIPOTARJETA_TITULAR_Y_ORO) {
            setErrorMDM(true);
            StorageHelper.setErrorManageOro(
              true,
              TarjetaOroHelper.getErrorByResponse(response.data, t),
            );
          } else if (tipoUsuario === TIPOTARJETA_NO_ORO) {
            addOro(true);
            addErrorBack(response.data);
          }
        } else if (typeof response.data.pojos !== 'undefined') {
          setPaises(response.data.pojos);
        }
      })
      .catch((e) => {
        console.log(e);
        addOro(true);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const getTipoUsuarioOro = () => {
    TarjetaService.getTipoUsuarioOro().then((response) => {
      if (!response.data.error) {
        setLoad(
          response.data ===
            TarjetasOroConstants.TIPO_USUARIO_ORO_CON_PASAPORTE ||
            response.data ===
              TarjetasOroConstants.TIPO_USUARIO_ORO_CON_PASAPORTE.toString(),
        );
      }
    });
  };

  const retrieveTiposVia = () => {
    TarjetaService.getTiposVia()
      .then((response) => {
        if (response.data.error) {
          const tipoUsuario = getTipoUsuarioTarjeta();

          if (tipoUsuario === TIPOTARJETA_TITULAR_Y_ORO) {
            setErrorMDM(true);
            StorageHelper.setErrorManageOro(
              true,
              TarjetaOroHelper.getErrorByResponse(response.data, t),
            );
          } else if (tipoUsuario === TIPOTARJETA_NO_ORO) {
            addOro(true);
            addErrorBack(response.data);
          }
        } else if (typeof response.data.pojos !== 'undefined') {
          setTiposVia(response.data.pojos);
        }
      })
      .catch((e) => {
        console.log(e);
        addOro(true);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const HandleChange = (
    key: string,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'postalCode':
        setPostalCode(e.target.value);
        break;
      case 'roadName':
        setRoadName(e.target.value);
        break;
      case 'door':
        setDoor(e.target.value);
        break;
      case 'floor':
        setFloor(e.target.value);
        break;
      case 'stairs':
        setStairs(e.target.value);
        break;
      case 'number':
        setNumber(e.target.value);
        break;
      case 'portal':
        setPortal(e.target.value);
        break;
      case 'localidad':
        setLocalidad(e.target.value);
        break;
      case 'cuenta':
        setCuenta(e.target.value);
        break;
    }
  };

  const HandleChangeSelect = (
    key: string,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'tipoVia':
        // eslint-disable-next-line no-case-declarations
        const index = e.target.selectedIndex;
        setRoadType(e.target.value);
        setRoadTypeDesc(e.target[index].innerText);
        break;
      case 'pais':
        console.log(e.target.value);
        setPais(e.target.value);
        break;
    }
  };

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getTipoUsuarioOro();
      retrieveTiposVia();
      getPaises();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token]);

  useEffect(() => {
    hideModalV2P();
    if (!visible) {
      showModalV2P();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (visible) {
      hideModalV2P();
      DataService.checkPrevalidacionDatos()
        .then((responsePrevalidacion) => {
          if (responsePrevalidacion.data.error) {
            setMessageError(
              t('tarjetas.hazte-oro.error-AME-prevalidation-message'),
            );
            if (
              responsePrevalidacion.data.errorCode ===
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
            ) {
              StorageHelper.setOpenV2PFromOro();
              StorageHelper.setOpenDireccionHabitual();
            }
            if (
              responsePrevalidacion.data.errorCode ===
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
            ) {
              StorageHelper.setOpenV2PFromOro();
              StorageHelper.setOpenOroPersonalData();
            }
            if (
              responsePrevalidacion.data.errorCode ===
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
            ) {
              StorageHelper.setOpenV2PFromOro();
              StorageHelper.setOpenOroPersonalData();
            }
            if (
              responsePrevalidacion.data.errorCode ===
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
            ) {
              StorageHelper.setOpenTelefonoError();
            }
            if (
              responsePrevalidacion.data.errorCode ===
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
            ) {
              showModalContactEmail();
            }
            hideModalV2P();
            setShowError(true);
          }
        })
        .catch((er: any) => {
          console.log(er);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    if (dataUser.user.email !== '') {
      IPManager.getMyIp(setIpValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.email]);

  const creatDataForsubmit = () => {
    const origenOro = StorageHelper.getSolicitudOroOrigin();
    return {
      cuota:
        cuota === 4
          ? TarjetasOroConstants.TIPO_CUOTA_4_STRING
          : TarjetasOroConstants.TIPO_CUOTA_6_STRING,
      cuotaSelect: cuota.toString(),
      cuentaBancaria: cuenta,
      locality: localidad,
      postalCode,
      roadName,
      number,
      portal,
      stairs,
      floor,
      door,
      codigoPaisAlfa2: pais,
      roadType,
      flagCondiciones: 1,
      flagAutorizacion: 1,
      fromApp: dataUser.user.isApp === 'false' ? 'web' : 'app_club',
      fromMenu: origenOro === BackMappings.TARJETA_CTA_ORO,
      datosIncompletos: isDatosIncompletos,
    };
  };

  const goBack = (reload: boolean) => {
    TarjetaOroHelper.resetForm(TarjetasOroConstants.FORM_ORO);
    StorageHelper.revomeNoroLabel();
    setVisible(false);
    if (reload && setReload !== undefined) {
      setReload(true);
    }
  };

  const reload = () => {
    StorageHelper.removeOpenPersonalData();
    TarjetaOroHelper.resetForm(TarjetasOroConstants.FORM_ORO);
    sessionStorage.removeItem('tipoUsuarioTarjetaOro');
    dataApp.loadHeader(dataApp.lang);

    const url = routerLoader.LoadRouterByPath('tarjeta-oro', dataApp.lang);
    if (setReload !== undefined) {
      setReload(true);
    }
    window.location.replace(url);
  };

  const doGoToMisdatos = (openDireccion: boolean, message: string) => {
    if (openDireccion) {
      if (message) {
        addOro(true);
        addWarning(message);
      }
      StorageHelper.setOpenFormOro();
      goBack(false);
    }
  };

  const showModalAltaOk = () => {
    const htmlText = TarjetaOroHelper.getModalConfirmarAltaOkHtml(
      t,
      dataUser,
      dataApp,
      routerLoader,
    );
    const title = t('tarjetas.tarjeta-oro-datos.alta-ok-title');
    setModalText(htmlText);
    setModalTitle(title);
    const label = StorageHelper.getNoroLabel();
    GtmManager.sendUpgradeNoroGTM(dataUser, dataApp, label, ipValue);
    StorageHelper.revomeNoroLabel();
    setShowModalConfirmacion(true);
  };

  const manageSolicitudResponse = (response: any) => {
    if (response.data.error === true) {
      addOro(true);
      addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
    } else {
      StorageHelper.removeOpenFormOro();
      const { pojo } = response.data;
      if (pojo) {
        const {
          message,
          isChanged,
          goToMisdatos,
          openDireccion,
          showOptions,
        } = pojo;

        if (isChanged) {
          // Limpiar el sessionStorage del tipo de tarjeta oro para forzar nueva consulta
          sessionStorage.removeItem('tipoUsuarioTarjetaOro');
          // Recargar el header para actualizar la configuración (solicitarTarjeta)
          dataApp.loadHeader(dataApp.lang);
          // Recargar la página después de un pequeño delay para que se actualice el header
          setTimeout(() => {
            const url = routerLoader.LoadRouterByPath(
              'tarjeta-oro',
              dataApp.lang,
            );
            window.location.replace(url);
          }, 500);
          showModalAltaOk();
        } else if (goToMisdatos) {
          doGoToMisdatos(openDireccion, message);
        } else if (showOptions) {
          setModalText(message);
          setShowModal(true);
        } else {
          setModalText(message);
          setModalTitle(t('tarjetas.tarjeta-socio.solicitud-title'));
          setShowModalConfirmacion(true);
        }
      }
    }
  };

  const submitForm = () => {
    const condicionesAceptadas = TarjetaOroHelper.areConditionsAccepted();
    if (condicionesAceptadas) {
      const data = creatDataForsubmit();
      TarjetaService.solicitarTarjetaOro(data)
        .then((response) => {
          if (!response.data.error && !response.data.pojo.situacionOro) {
            GtmManager.sendActivarOroGTM(
              GtmConstants.GOLD_CARD_REQUEST,
              GtmConstants.GOLD_CARD,
              data.cuotaSelect,
              GtmConstants.ALTA_ORO_STEP,
              t('tarjetas.hazte-oro.to-request'),
            );
          }
          manageSolicitudResponse(response);
        })
        .catch(() => {
          addOro(true);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
        });
    }
  };

  const selected4 = () => {
    TarjetaOroHelper.selectCuota(4);
    setCuota(4);
  };
  const selected6 = () => {
    TarjetaOroHelper.selectCuota(6);
    setCuota(6);
  };

  const aceptarConfirmacionSolicitud = () => {
    setShowModal(false);
    submitForm();
  };

  const aceptarGoToMisdatos = () => {
    StorageHelper.setOpenV2P(false);
    window.location.href = routerLoader.LoadRouterByPath(
      'mis-datos',
      dataApp.lang,
    );
  };

  const goToMisDatosAndOpenDatosPersonales = () => {
    StorageHelper.setOpenOroPersonalData(); // setOpenPersonalData
    aceptarGoToMisdatos();
  };
  useEffect(() => {
    if (!dataUser.user.titular && StorageHelper.isOpenFormularioOro()) {
      setShowErrorOro(true);
    }
  }, []);
  const goGoToF2 = () => {
    setShowError(false);
    setShowErrorOro(true);
    StorageHelper.setTarjetaOroPopup('false');
    document.location.href = `${HostProvider.getHost()}${
      dataApp.lang
    }/nlrRegistrar/noTitular/tarjetas?fromApp=${
      dataUser.user.fromApp
    }&origenAP=tarjetas&altaOroExterna=true`;
  };
  if (!isDatosIncompletos) {
    return (
      <>
        <section
          className={`o-section--large form-oro bloque-form ${
            visible ? 'visible' : ''
          }`}
        >
          <div className="container">
            <a
              id="link-back"
              className="link-prev"
              onClick={() => {
                goBack(false);
              }}
            >
              <div className="icon icon-medium">
                <IconBack />
              </div>
              <p className="u-font-normal u-text-brand u-margin-left">
                {t('datos.accessdata.back')}
              </p>
            </a>

            <legend className="bloque-datos__title">
              <span className="divider__square brand-gold-color" />
              <span className="u-margin-right">
                {t('tarjetas.hazte-oro.request-gold-card')}
              </span>
            </legend>
            <fieldset>
              <div className="row u-margin-bottom">
                <div className="col-12 col-md-8">
                  <div className="form-group u-margin-bottom-large">
                    <label htmlFor="cuenta" className="control-label">
                      {t('tarjetas.hazte-oro.choose-fee')}
                    </label>

                    <div className="tabs-block__selector">
                      <a
                        id="selected-4"
                        onClick={selected4}
                        className="tabs-block__selector-item active"
                      >
                        {TarjetasOroConstants.CUATRO_POR_CIENTO}
                      </a>
                      <a
                        id="selected-6"
                        onClick={selected6}
                        className="tabs-block__selector-item"
                      >
                        {TarjetasOroConstants.SEIS_POR_CIENTO}
                      </a>
                    </div>
                    <div id="result-4" className="tabs-block__cuota active">
                      {`${priceFormatter(TarjetasOroConstants.CUOTA_BAJA)} ${t(
                        'tarjetas.hazte-oro.cuota-al-mes',
                      )}`}
                    </div>
                    <div id="result-6" className="tabs-block__cuota">
                      {`${priceFormatter(TarjetasOroConstants.CUOTA_ALTA)} ${t(
                        'tarjetas.hazte-oro.cuota-al-mes',
                      )}`}
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <FacturacionOroForm
              handleChange={HandleChange}
              handleChangeSelect={HandleChangeSelect}
              tiposVia={tiposVia}
              load={load}
              submitForm={submitForm}
              paises={paises}
              isDatosIncompletos={false}
              cuota={cuota}
            />
          </div>
        </section>
        <ModalConfirmacion
          isBig={false}
          isSmall
          isOro
          textCentered={false}
          showModal={showModal}
          setShowModal={setShowModal}
          title={t('tarjetas.tarjeta-socio.solicitud-title')}
          textHTMLContent={modalText}
          doAceptar={aceptarConfirmacionSolicitud}
          doClose={emptymethod}
          showCancel
          cancelButtonTextKey={t('tarjetas.tarjeta-oro-datos.otro-momento')}
          acceptButtonTextKey={t('tarjetas.tarjeta-oro-datos.reintentar')}
          hideXButton
        />
        <ModalConfirmacion
          isBig={false}
          isSmall
          isOro
          textCentered={false}
          showModal={showModalConfirmacion}
          setShowModal={setShowModalConfirmacion}
          title={modalTitle}
          textHTMLContent={modalText}
          doAceptar={reload}
          doClose={emptymethod}
          showCancel={false}
          acceptButtonTextKey={t('datos.accessdata.accept')}
          hideXButton
        />
        <ModalConfirmacion
          isBig={false}
          isSmall
          textCentered
          showModal={showError}
          setShowModal={setShowError}
          title={t(titleError)}
          textHTMLContent={t(messageError)}
          doAceptar={aceptarGoToMisdatos}
          doClose={emptymethod}
          showCancel={false}
          acceptButtonTextKey={t('datos.accessdata.accept')}
          hideXButton
        />
        <ModalConfirmacion
          isBig={false}
          isSmall
          textCentered
          isOro
          showModal={showErrorOro}
          setShowModal={setShowErrorOro}
          title={t(titleError)}
          textHTMLContent={t('tarjetas.hazte-oro.activate-my-card-body')}
          doAceptar={goGoToF2}
          doClose={emptymethod}
          showCancel={false}
          acceptButtonTextKey={t('tarjetas.hazte-oro.activate-my-card-button')}
          hideXButton
        />
      </>
    );
  } else {
    return (
      <>
        <section className="o-section u-padding-top-hero u-padding-bottom-hero">
          <div className="container-inner">
            <div className="tarjeta__content tarjeta-oro__content">
              <h2 className="bloque-datos__title">
                <span className="divider__square brand-gold-color" />
                <span className="u-margin-right">
                  {t('tarjetas.tarjeta-oro-datos.completa-tus-datos')}
                </span>
              </h2>
            </div>
            <FacturacionOroForm
              handleChange={HandleChange}
              handleChangeSelect={HandleChangeSelect}
              tiposVia={tiposVia}
              load={load}
              submitForm={submitForm}
              paises={paises}
              isDatosIncompletos
              cuota={cuota}
            />
          </div>
        </section>
        <ModalConfirmacion
          isBig={false}
          isSmall
          isOro
          textCentered={false}
          showModal={showModal}
          setShowModal={setShowModal}
          title={t('tarjetas.tarjeta-socio.solicitud-title')}
          textHTMLContent={modalText}
          doAceptar={aceptarConfirmacionSolicitud}
          doClose={emptymethod}
          showCancel
          acceptButtonTextKey={t('tarjetas.tarjeta-oro-datos.reintentar')}
          cancelButtonTextKey={t('tarjetas.tarjeta-oro-datos.otro-momento')}
          hideXButton
        />
        <ModalConfirmacion
          isBig={false}
          isSmall
          isOro
          textCentered={false}
          showModal={showModalDatos}
          setShowModal={setShowModalDatos}
          title={t('tarjetas.tarjeta-socio.solicitud-title')}
          textHTMLContent={modalText}
          doAceptar={goToMisDatosAndOpenDatosPersonales}
          doClose={emptymethod}
          showCancel={false}
          cancelButtonTextKey={t('tarjetas.tarjeta-oro-datos.otro-momento')}
          acceptButtonTextKey={t('datos.accessdata.accept')}
          hideXButton
        />
        <ModalConfirmacion
          isBig={false}
          isSmall
          isOro
          textCentered={false}
          showModal={showModalConfirmacion}
          setShowModal={setShowModalConfirmacion}
          title={modalTitle}
          textHTMLContent={modalText}
          doAceptar={reload}
          doClose={emptymethod}
          showCancel={false}
          acceptButtonTextKey={t('datos.accessdata.accept')}
          hideXButton
        />
        <ModalConfirmacion
          isBig={false}
          isSmall
          textCentered
          showModal={showError}
          setShowModal={setShowError}
          title={t(titleError)}
          textHTMLContent={t(messageError)}
          doAceptar={aceptarGoToMisdatos}
          doClose={emptymethod}
          showCancel={false}
          acceptButtonTextKey={t('datos.accessdata.accept')}
          hideXButton
        />
      </>
    );
  }
};
export default SolictarTarjetaOroForm;
